import { Logger, type Analytic } from '@terros/common'
import { listeners } from './listener'

const logger = new Logger('Analytics')

export type AnalyticWithoutMetadata = Omit<Analytic, 'event' | 'timestamp'>

export function trackAnalytic(event: string, analytic?: AnalyticWithoutMetadata): void {
  const now = Date.now()
  let exists = false
  for (const listener of listeners.values()) {
    exists = true
    listener({
      ...analytic,
      event,
      timestamp: now,
    })
  }
  if (!exists) logger.warn('Analytic event tracked with no listeners registered!')
}
